import { generatePath } from 'react-router-dom'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { Link } from 'components/Link'
import { formatLocalDateUTC } from 'utils/date'
import { links } from 'utils/featureToggles'
import { formatNumber } from 'utils/normalizers'

export const clientDetailsWalletColumns: GridColumnProps[] = [
  {
    title: 'Wallet number',
    field: 'name',
    cell: (props: GridCellProps) => (
      <td style={{ color: 'var(--link)', textDecoration: 'underline' }}>
        <Link
          to={{
            pathname: generatePath(links.recordsWallets.detailsUrl as string, {
              id: props.dataItem.id,
              slug: 'details',
            }),
          }}
        >
          {props.dataItem.name}
        </Link>
      </td>
    ),
    className: 'clients-table-columns__content',
  },
  {
    title: 'Type',
    field: 'walletType.name',
    className: 'clients-table-columns__content',
  },
  {
    title: 'Currency',
    field: 'currency.id',
    className: 'clients-table-columns__content',
  },
  {
    title: 'Reserved',
    field: 'reserved',
    className: 'clients-table-columns__content',
    cell: (props: GridCellProps) => {
      const { reserved } = props.dataItem
      if (reserved) {
        return (
          <td className='clients-table-columns__number'>{formatNumber(reserved.toFixed(2))}</td>
        )
      }
      return <td className='clients-table-columns__number'>0.00</td>
    },
  },
  {
    title: 'Bonus Reserved',
    field: 'bonusReserved',
    cell: (props: GridCellProps) => {
      const { bonusReserved } = props.dataItem
      if (bonusReserved) {
        return (
          <td className='clients-table-columns__number'>
            {formatNumber(bonusReserved.toFixed(2))}
          </td>
        )
      }
      return <td className='clients-table-columns__number'>0.00</td>
    },
  },
  {
    title: 'Balance',
    field: 'balance',
    className: 'clients-table-columns__content',
    cell: (props: GridCellProps) => {
      const { balance } = props.dataItem
      if (balance) {
        return (
          <td className='k-font-weight-bold clients-table-columns__number'>
            {formatNumber(balance.toFixed(2))}
          </td>
        )
      }
      return <td className='k-font-weight-bold clients-table-columns__number'>0.00</td>
    },
  },
  {
    title: 'Pending',
    field: 'pending',
    cell: (props: GridCellProps) => {
      const { pending } = props.dataItem
      if (pending) {
        return <td className='clients-table-columns__number'>{formatNumber(pending.toFixed(2))}</td>
      }
      return <td className='clients-table-columns__number'>0.00</td>
    },
    className: 'clients-table-columns__content',
  },
  {
    title: 'Date Created',
    field: 'createdDate',
    cell: (props: GridCellProps) => (
      <td className='clients-table-columns__date'>
        {formatLocalDateUTC(props.dataItem.createdDate, true)}
      </td>
    ),
    className: 'clients-table-columns__content',
  },
]
